import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
  withNoIncrementalHydration,
} from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { provideNglConfig } from '@vallift/ngl';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { provideNgxMask } from 'ngx-mask';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled'
    }), withComponentInputBinding()),
    provideClientHydration(withEventReplay(), withNoIncrementalHydration()),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAngularSvgIcon(),
    provideNglConfig({
      baseApiUrl: environment.baseUrl,
      enableUnsavedChangesWarning: true,
      enableDevTools: true,
      overlay: {
        showHeaderBorder: false,
        showActionsBorder: false,
      },
      pagination: {
        pageSize: 50,
        pageSizeOptions: [25, 50, 100, 200],
      },
      listResponse: {
        data: 'data.items',
        totalCount: 'data.totalCount',
        pageNumber: 'data.pageNumber',
        pageSize: 'data.pageSize',
      },
    }),
    provideNgxMask(),
  ],
};
